export function datetimeGrammar(solve: boolean) {
  const varValue = solve ? 'return null' : '$$ = ``';
  return {
    lex: {
      rules: [
        ['\\s+', '/* skip whitespace */'],
        ['\\$\\w+', 'return `VARIABLE`'],
        ['=', 'return `BEGEXP`'],
        ['"', 'return `QUOT`'],
        ['\/', 'return `/`'],
        ['(0?[1-9]|1[012])', 'return `MM`'],
        ['(0?[1-9]|[12][0-9]|3[01])', 'return `DD`'],
        ['\\d\{4\}', 'return `YYYY`'],
        ['NOW|now', 'return `NOW`'],
        // ['0?[0-9]|[1][0-9]|2[01234]', 'return `HH`'],
        // ['0?[0-9]|[12345][0-9]', 'return `0-59`'],
        // ['\-', 'return `-`'],
        // ['[12]\\d\\d\\d\\-(0?[1-9]|1[012])\\-(0?[1-9]|[12][0-9]|3[01])', 'return USDATE'],
        // ['[1-9]+[Dd]', 'return `ADD`'],
        // ['\+', 'return `+`'],
        ['$', 'return `EOF`']
      ]
    },
    operators: [],
    bnf: {
      expressions: [['BEGEXP e EOF', 'return $2']],
      e: [
        ['DD / e', '$$ = $1'],
        ['e / YYYY', '$$ = $3'],
        ['/ MM /', '$$ = $2'],


        // ['YYYY - MM - DD', '$$ = new Date($e1, $e2, $e3)'],
        // ['DD / MM / YYYY', '$$ = new Date($e3, $e2, $e1)'],
        // ['HH : 0-59 : 0-59', '$$ = new Date(0, 0, 0, $e1, $e2, $e3)'],
        // ['QUOT MM QUOT', '$$ = 0'],
        ['NOW', '$$ = Date.now()'],
        // ['e + ADD', '$$ = ``'],
        // ['e + ADD', '$$ = {const ret = new Date($e1); return ret.setDate(ret.getDate() + parseInt($e2))}'],
        ['VARIABLE', varValue]
      ]
    }
  };
}
